import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddUnitLayer from "../components/AddUnitLayer";

export const AddUnitPage = () => {
  return (
    <MasterLayout>
      {/* <Breadcrumb title="Add / Edit Outlet" /> */}
    <AddUnitLayer/>
    </MasterLayout>
  );
};
